import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// import PropTypes from "prop-types";
import RemoveCardTabWorkers from "./RemoveCardTabWorkers";
import {I18nUtils} from "../../../i18n/I18nUtils";
import Row from "../../shared/components/Row";
import Card from "../../shared/components/Card";
import CardBody from "../../shared/components/CardBody";
import RemoveCardTabMachines from "./RemoveCardTabMachines";
import StateManager from "../../shared/utils/StateManager";
import * as removeActions from "../actions/removeActions";

class RemoveCard extends React.Component {

  constructor(init) {
    super(init);

    this.removeAction = this.removeAction.bind(this);
  }

  componentWillMount() {
    StateManager.clearRemove();
  }

  removeAction() {
    this.props.removeActions.removeWithoutCommit(
      this.props.companies.map(company => company.id),
      this.props.workers.map(worker => worker.id),
      this.props.machines.map(machine => machine.id)
    );
  }

  renderExportButton() {
    if (this.props.enableRemove) {
      return(
        <a
          onClick={this.removeAction}
          className={'btn btn-danger btn-lg waves-effect waves-float'}
        >{I18nUtils.tr('TR_ELIMINAR').toUpperCase()}</a>
      );
    }
  }

  render() {
    return (
      <Row>
        <Card colWidth={'col-md-12'} loading={this.props.loading}>
          <CardBody className={'table-responsive'}>
            <ul className="nav nav-tabs" role="tablist">
              {RemoveCardTabWorkers.renderTabHeader()}
              {RemoveCardTabMachines.renderTabHeader()}
            </ul>

            <div className="tab-content">
              <RemoveCardTabWorkers />
              <RemoveCardTabMachines />
            </div>

            <div className="text-right">
              {this.renderExportButton()}
            </div>

          </CardBody>
        </Card>
      </Row>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  let removeCount = 0;
  removeCount += state.remove.companies.length;
  removeCount += state.remove.workers.length;
  removeCount += state.remove.machines.length;
  return {
    enableRemove: removeCount > 0,
    loading: state.remove.loading,

    companies: state.remove.companies,
    workers: state.remove.workers,
    machines: state.remove.machines,
  }
};

const mapDispatchToProps = dispatch => ({
  removeActions: bindActionCreators(removeActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveCard)

RemoveCard.propTypes = {
};

RemoveCard.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/remove/components/RemoveCard.js